import { render, staticRenderFns } from "./ModificaLavoro.vue?vue&type=template&id=1e219c4d"
import script from "./ModificaLavoro.vue?vue&type=script&lang=js"
export * from "./ModificaLavoro.vue?vue&type=script&lang=js"
import style0 from "./ModificaLavoro.vue?vue&type=style&index=0&id=1e219c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports